const Map = () => {
  return (
    <section>
      <iframe
        title="map montreal"
        src="https://www.google.com/maps/embed?pb=!1m10!1m8!1m3!1d16728724.84713118!2d-53.01830731623618!3d43.628645635201416!3m2!1i1024!2i768!4f13.1!5e0!3m2!1spl!2spl!4v1622108709992!5m2!1spl!2spl"
        width="100%"
        height="300"
        frameBorder="0"
        style={{ border: 0 }}
        allowFullScreen=""
        aria-hidden="false"
        tabIndex="0"
      />
    </section>
  );
};

export default Map;
